import React from 'react';
import ReactDOM from 'react-dom/client';
import OpalByMario from './OpalByMario';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <OpalByMario />
  </React.StrictMode>
);
